import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";

import {
  catchError,
  map,
  switchMap,
  tap,
} from "rxjs/operators";
import {  of } from "rxjs";
import { ContactDetailsActions } from "../../actions/contact-details/contact-details.actions";
import { ContactDetailsService } from "@services/contact-details.service";
import { ConfirmationModalComponent } from "@components/confirmation-modal/confirmation-modal.component";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { EditAddOrganizationContactModalComponent } from "@components/modals/edit-add-org-contact-modal/edit-add-org-contact-modal.component";

@Injectable()
export class ContactDetailsEffects {
  createOrganizationContact$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ContactDetailsActions.addContactSave),
      switchMap((action) => {
        return this.contactDetailsService
          .createOrganizationContact(action.data)
          .pipe(
            map((data) =>
              ContactDetailsActions.contactSavedSuccess({ data: data })
            ),
            catchError((error) =>
              of(ContactDetailsActions.contactSavedFailure({ error }))
            )
          );
      })
    );
  });

  updateOrganizationContact$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ContactDetailsActions.editContact),
      switchMap((action) => {
        return this.contactDetailsService
          .updateOrganizationContact(action.data)
          .pipe(
            map((data) =>
              ContactDetailsActions.editContactSuccess({ data: data })
            ),
            catchError((error) =>
              of(ContactDetailsActions.editContactFailure({ error }))
            )
          );
      })
    );
  });

  deleteOrganizationContact$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ContactDetailsActions.deleteContact),
      switchMap((action) => {
        return this.contactDetailsService
          .deleteOrganizationContact(action.id)
          .pipe(
            map((data) =>
              ContactDetailsActions.deleteContactSuccess({ id: action.id })
            ),
            catchError((error) =>
              of(ContactDetailsActions.deleteContactFailure({ error }))
            )
          );
      })
    );
  });

  openAddContactPressed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ContactDetailsActions.openAddContactPressed),
        tap(() => {
          this.dialog.open(EditAddOrganizationContactModalComponent, {
            data: {
              title: "Create Contact",
            },
          });
        })
      ),
    { dispatch: false }
  );

  openEditContactPressed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ContactDetailsActions.openEditContactPressed),
        tap((action) => {
          this.dialog.open(EditAddOrganizationContactModalComponent, {
            data: {
              title: "Create Contact",
              contact: action.contact,
            },
          });
        })
      ),
    { dispatch: false }
  );

  openDeleteContactPressed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ContactDetailsActions.openDeleteContactPressed),
        tap((action) => {
          const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            data: {
              title: "Delete Contact Confirmation",
              content: `Are you sure you want to delete: ${action.name}?`,
            },
          });

          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.store.dispatch(
                ContactDetailsActions.deleteContact({ id: action.id })
              );
            } else {
              dialogRef.close();
            }
          });
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private contactDetailsService: ContactDetailsService,
    private dialog: MatDialog,
    private store: Store
  ) {}
}
